export default {
  firstname: 'שם פרטי',
  lastname: 'שם משפחה',
  fullName: 'שם מלא',
  agentType: 'תפקיד',
  uid: 'תעודת זהות',
  dob: 'תאריך לידה',
  email: 'דואר אלקטרוני',
  phone: 'טלפון',
  cellphone: 'נייד',
  extracellphone: 'נייד נוסף',
  website: 'אתר אנטרנט',
  spousePhone: 'נייד של בן/ת זוג',
  spouseEmail: 'דואר אלקטרוני של בן/ת זוג',
  gender: 'מין',
  male: 'זכר',
  female: 'נקבה',
  homeaddress: 'כתובת מגורים',
  city: 'עיר',
  employeeType: 'סוג סוכן',
  street: 'רחוב',
  houseNumber: 'מספר בית',
  zipCode: 'מיקוד',
  postalCode: 'ת.ד',
  homephone: 'טלפון בית',
  officeaddress: 'כתובת משרד',
  officephone: 'טלפון משרד',
  status: 'סטטוס',
  familystatus: 'מצב משפחתי',
  spouse: 'שם בן / בת זוג',
  numberOfChildren: 'מספר ילדים',
  haveChildren: 'יש ילדים?',
  addChildren: 'הוספת ילד',
  policyend: 'תאריך תום פוליסה אחריות מקצועית',
  licenseend: 'תאריך תום רשיון',
  tax: 'תאריך ניכוי מס וניהול ספרים',
  license: 'תאריך תוקף רישיון סוכן',
  professionalPolicy: 'תאריך פוליסה מקצועית',
  verifyDeletion: 'האם אתה בטוח שברצונך להעביר את הסוכן לארכיון?',
  deletionReason: 'סיבת המחיקה',
  headers: {
    home: 'כתובת',
    office: 'כתובת משרד',
    private: 'פרטים אישיים',
    contact: 'פרטי קשר',
    childrens: 'פרטי ילדים',
    adminDetails: 'פרטים מנהליים',
  },
};
